import Vue from 'vue';
import Vuex from 'vuex';
import Common from './api/common';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		User: null,
		currentAccountSets: null,
		myAccountSets: [],
		sliderCollapsed: false,
		authReady: false,
		isAuthenticated: false
	},
	mutations: {
		updateAccount(state, data) {
			state.User = data || null;
			state.currentAccountSets = data && data.accountSets ? data.accountSets : null;
			state.myAccountSets = data && data.accountSetsList ? data.accountSetsList : [];
			state.isAuthenticated = true;
			state.authReady = true;
		},
		clearAccount(state) {
			state.User = null;
			state.currentAccountSets = null;
			state.myAccountSets = [];
			state.isAuthenticated = false;
			state.authReady = true;
		},
		setAuthReady(state, ready) {
			state.authReady = ready;
		},
		updateSliderCollapse(state, isShow) {
			setTimeout(() => {
				G.trigger('page_resize');
			}, 600);
			state.sliderCollapsed = isShow;
		}
	},
	actions: {
		init(context) {
			return Common.init().then(({ data }) => {
				context.commit('updateAccount', data);
				return data;
			});
		},
		bootstrap(context, options = {}) {
			const force = options.force === true;
			if (context.state.authReady && !force) {
				return Promise.resolve(context.state.User);
			}
			context.commit('setAuthReady', false);
			return context.dispatch('init').catch(() => {
				context.commit('clearAccount');
				return null;
			});
		},
		logout(context) {
			return Common.logout().finally(() => {
				context.commit('clearAccount');
			});
		}
	},
	getters: {
		account: state => state.User || {},
		sliderCollapsed: state => state.sliderCollapsed,
		isAuthenticated: state => state.isAuthenticated
	}
});
